import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Lenis from "lenis";
import Navbar from "@/components/washflow/Navbar";
import Hero from "@/components/washflow/Hero";
import Marquee from "@/components/washflow/Marquee";
import Problem from "@/components/washflow/Problem";
import Phase1 from "@/components/washflow/Phase1";
import PhotoBand from "@/components/washflow/PhotoBand";
import Phase2 from "@/components/washflow/Phase2";
import Pricing from "@/components/washflow/Pricing";
import Reporting from "@/components/washflow/Reporting";
import Addons from "@/components/washflow/Addons";
import Calculator from "@/components/washflow/Calculator";
import Contact from "@/components/washflow/Contact";
import Footer from "@/components/washflow/Footer";
import Reveal from "@/components/washflow/Reveal";
import Admin from "@/pages/Admin";

const Home = () => (
  <main className="bg-white">
    <Navbar />
    <Hero />
    <Marquee />
    <Reveal><Problem /></Reveal>
    <Reveal><Phase1 /></Reveal>
    <PhotoBand />
    <Reveal><Phase2 /></Reveal>
    <Reveal><Pricing /></Reveal>
    <Reveal><Reporting /></Reveal>
    <Reveal><Addons /></Reveal>
    <Reveal><Calculator /></Reveal>
    <Reveal><Contact /></Reveal>
    <Footer />
  </main>
);

function App() {
  useEffect(() => {
    const lenis = new Lenis({ anchors: true, lerp: 0.09 });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
